import { User } from "../models/User";
import axiosInstance from "./axiosInstance";
import Cookies from "js-cookie";

const registerUser = async (user: Partial<User>) => {
  const response = await axiosInstance.post("auth/register", user);
  return response.data;
};

const loginUser = async (credentials: { email: string; password: string }) => {
  try {
    const response = await axiosInstance.post("auth/login", credentials);
    if (response.data && response.data.accessToken) {
      Cookies.set("access_token", response.data.accessToken, {
        expires: 1 / 24,
        secure: process.env.NODE_ENV === "production",
        sameSite: "strict",
        path: "/",
      });
      return response.data;
    }
  } catch (error) {
    throw new Error("Login failed");
  }
};

const getCurrentUser = async () => {
  const response = await axiosInstance.get("auth/profile");
  return response.data;
};

const sendOtp = async (email: string) => {
  const response = await axiosInstance.post("auth/get-otp", { email });
  return response.data;
};

const verifyOtp = async (data: { otp: string }) => {
  const response = await axiosInstance.post("auth/verify-otp", data);

  return response.data;
};

const sendEmailResetPassword = async (email: string) => {
  const response = await axiosInstance.post("auth/confirm-email", {
    email: email,
  });

  return response.data;
};

const verifyEmailToken = async (token: string) => {
  const response = await axiosInstance.post("auth/verify-email-token", {
    token,
  });
  return response.data;
};

const resetPassword = async (email: string, password: string) => {
  const response = await axiosInstance.post("auth/reset-password", {
    email,
    password,
  });
  return response.data;
};

// service for user to confirm password
const confirmPassword = async (password: string) => {
  const response = await axiosInstance.post("/auth/confirm-password", {
    password,
  });
  return response.data;
};

const logout = async () => {
  const response = await axiosInstance.post("/auth/logout");
  return response.data;
};

const refreshToken = async () => {
  const response = await axiosInstance.get("/auth/refresh");
  return response.data;
}

export const AuthService = {
  getCurrentUser,
  sendOtp,
  verifyOtp,
  registerUser,
  loginUser,
  sendEmailResetPassword,
  verifyEmailToken,
  resetPassword,
  confirmPassword,
  logout,
  refreshToken,
};
